// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"804e0655","845":"43f1b754"}[chunkId] + ".chunk.js";
};